import React, {Component} from 'react'
import {findDOMNode} from 'react-dom'
import {style, media, merge, after} from 'glamor'
import * as colors from '../../colors'
import {ButtonCircle} from 'rebass'
import {Arrow} from 'reline'
import Label from '../Label'
import Thumb from '../ThumbProject'
import {Link, Match} from 'react-router'
import ProjectList from '../ProjectList'
import Project from './ProjectDesktop'
import { Scrollbars } from 'react-custom-scrollbars'
import AutoSizer from '../AutoSizer'
import find from 'lodash.find'

const SIDEBAR_SIZE = '30%'

export default class Category extends Component {

  shouldComponentUpdate(){
    return false
  }

  constructor(props){
    super(props)
    this.direction = 1
  }

  componentWillReceiveProps(newProps){
    const path = this.props.location.pathname
    const newPath = newProps.location.pathname
    if( newPath !== path){
      this.direction = newPath.indexOf(path) > -1 ? 1 : -1
    }
  }

  render(){

    const gallery = find(this.props.pages, {url: `/${this.props.params.type}`})
    const category = find(gallery.items, {id: this.props.params.category})

    return (
      <div
        {...merge(
          style({
            background: colors.nearBlack,
            width: '100%',
            minHeight: '100vh',
            color: colors.white,
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 9,
            perspective: 500,
            display: 'flex'
          }),
          media('(min-width: 800px)', {
          })
      )}
      >
        <Link
          to={`/${this.props.params.type}`}
          ref='btnMenu'
          {...merge(
            style({
              cursor: 'pointer',
              position: 'fixed',
              top:0,
              padding: '1rem',
              right: 0,
              zIndex: 9,
            }),
            media('(min-width: 800px)', {
              padding: '2rem'
            }),
            media('(min-width: 1000px)', {
              padding: '4rem'
            })
          )}
        >
          <ButtonCircle
            size={40}
            color={colors.nearBlack}
            backgroundColor={colors.yellow}
          >
            <Arrow left style={{display: 'block'}}strokeWidth={2}/>
          </ButtonCircle>
        </Link>


          <div
            {...merge(
              style({
                position: 'relative',
                background: colors.black10,
                width: '40%',
                height: '100vh',
                // // position: 'fixed',
                // top: 0,
                // left: 0,
                // overflow: 'auto'
                // width: ''
              }),
              media('(min-width: 1200px)', {
                width: '25%',
              }),

            )}
          >

          <AutoSizer>
          { ({width, height}) => (
            <Scrollbars

              autoHide={true}
              renderTrackVertical={ props => (
                <div
                  {...props}
                  {...style({
                    right: 0,
                    // background: colors.darkGray,
                    width: 10,
                    height: '100%'
                  })}
                />
              )}
              renderThumbVertical={ props => (
                <div
                  {...props}
                  {...style({
                    background: colors.yellow,
                    width: 10,
                    height: '100%'
                  })}
                />
              )}
              onScroll={(evt)=>evt.stopPropagation()}
              style={{ width: width, height: height }}
            >
                <div
                  {...merge(
                    style({
                      position: 'relative',
                      padding: '1.5rem'
                    }),
                    media('(min-width: 800px)', {
                      padding: '2rem'
                    }),
                    media('(min-width: 1000px)', {
                      padding: '4rem 2rem'
                    })

                  )}
                >
                  <div
                    {...merge(
                      style({
                        marginBottom: '2rem'
                      }),
                      media('(min-width: 800px)', {
                        marginBottom: '2rem'
                      }),
                      media('(min-width: 1000px)', {
                        marginBottom: '3.5rem'
                      })
                    )}
                  >
                    <Label color={colors.yellow}>
                      {category.title}
                    </Label>
                  </div>

                  <ProjectList
                    pathname={`/${this.props.params.type}/${this.props.params.category}`}
                    items={category.items}
                  />

                </div>
              </Scrollbars>
            )}</AutoSizer>
          </div>


          <div
            {...style({
              flex: '1 1 auto',
              position: 'relative',
              height: '100vh',
            })}
          >
            <div
              {...style({
                position: 'absolute',
                top: 0,
                left: 0,
                width: '10px',
                bottom: 0,
                zIndex: 1,
                background: 'linear-gradient(to left, rgba(0,0,0,0) 0%,rgba(0,0,0, 0.4) 100%)'
              })}
            />
            <Match
              pattern={`/:type/:category/:id`}
              render={(matchProps) => (
                <Project key={matchProps.params.id} pages={this.props.pages} {...matchProps}/>
              )}
            />
          </div>


      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/pages/Category.js
 **/